export default {
  maxUploadSize: 5242880 // 5 mb in bytes
}
